var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showBulkUpdate
    ? _c(
        "modal-box",
        {
          attrs: { open: _vm.showBulkUpdate },
          domProps: {
            onClose: _vm.hideBulkUpdate,
            enableHeader: true,
            enableFooter: true,
            enableHeaderClose: true,
            transparentOverlay: false,
            closeOnClickOutside: true,
          },
        },
        [
          _vm.dataLoading
            ? _c("div", { staticClass: "popup" }, [_c("eas-loader")], 1)
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", { staticClass: "flex-row flex-1" }, [
                _c("div", { staticClass: "flex-col flex-1" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("bulkUpdate")))]),
                ]),
              ]),
            ]
          ),
          _vm.uploadContainsErrors
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "flex-col pr-1" },
                  [
                    _c("div", { staticClass: "flex-row pr-2 mb-1" }, [
                      _vm._v(" " + _vm._s(_vm.$t("errorBulkUpdate")) + " "),
                    ]),
                    _vm._l(
                      _vm.bulkUpdateResult.validationIssues,
                      function (validationIssue) {
                        return _c(
                          "div",
                          {
                            key: validationIssue.cellAddress,
                            staticClass: "flex-row pr-2",
                          },
                          [
                            _c("div", { staticClass: "flex-1 mr-2" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("cellRow")) +
                                  " " +
                                  _vm._s(validationIssue.cellAddress) +
                                  ": "
                              ),
                            ]),
                            _c("div", { staticClass: "flex-2" }, [
                              _vm._v(
                                " " + _vm._s(validationIssue.message) + " "
                              ),
                            ]),
                          ]
                        )
                      }
                    ),
                  ],
                  2
                ),
              ])
            : _vm.showBulkUpdateResults
            ? _c("div", [
                _c("div", { staticClass: "flex-col pr-1" }, [
                  _c("div", { staticClass: "flex-row pr-2" }, [
                    _vm._v(" " + _vm._s(_vm.$t("bulkUpdateSuccessful")) + " "),
                  ]),
                  _vm.bulkUpdateResult.numberOfUpdates > 0
                    ? _c("div", { staticClass: "flex-row pr-2" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("numberOfChangedRecords")) +
                            " " +
                            _vm._s(_vm.bulkUpdateResult.numberOfUpdates) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "flex-row pr-2" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("numberOfAddedRecords")) +
                        " " +
                        _vm._s(_vm.bulkUpdateResult.numberOfInserts) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "flex-row pr-2" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("totalRecords")) +
                        " " +
                        _vm._s(_vm.bulkUpdateResult.totalRecords) +
                        " "
                    ),
                  ]),
                ]),
              ])
            : _vm.showConfirmChanges
            ? _c("div", [
                _c("div", { staticClass: "flex-col pr-1" }, [
                  _vm.bulkUpdateResult.numberOfUpdates > 0
                    ? _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("recordsToBeUpdated")) +
                            ": " +
                            _vm._s(_vm.bulkUpdateResult.numberOfUpdates)
                        ),
                      ])
                    : _vm._e(),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("recordsToBeAdded")) +
                        ": " +
                        _vm._s(_vm.bulkUpdateResult.numberOfInserts)
                    ),
                  ]),
                  _c("p", [_vm._v(_vm._s(_vm.$t("continueConfirmation")))]),
                ]),
              ])
            : _c("div", [
                _c("input", {
                  attrs: {
                    type: "file",
                    accept:
                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.changeBulkUpdateFile($event)
                    },
                  },
                }),
              ]),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("div", { staticClass: "flex-row reverse" }, [
                _c("div", { staticClass: "flex-col flex-align-end mt-1" }, [
                  _vm.uploadContainsErrors || _vm.showBulkUpdateResults
                    ? _c(
                        "button",
                        {
                          staticClass: "btn",
                          on: {
                            click: function ($event) {
                              return _vm.hideBulkUpdate()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("close")) + " ")]
                      )
                    : _vm.showConfirmChanges
                    ? _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn",
                            on: {
                              click: function ($event) {
                                return _vm.continueUploadBulkUpdateFile()
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("continue")) + " ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn",
                            on: {
                              click: function ($event) {
                                return _vm.hideBulkUpdate()
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                        ),
                      ])
                    : _c(
                        "button",
                        {
                          staticClass: "btn",
                          attrs: {
                            disabled: _vm.selectedBulkUpdateFile === null,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showConfirmation()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("uploadFile")) + " ")]
                      ),
                ]),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }